import { useAuthenticatedWebSocket } from "@/libs/web-sockets";
import { useSnackbar } from "notistack";
import { useEffect } from "react";

type NotificationType = {
  id: number;
  read_at: string | null;
  dismissed_at: string | null;
  notification_body: {
    created_at: string;
    event_type: "Application" | "Product" | "Generic";
    sub_type: "Warning" | "Information";
    expires_at: string | null;
    message: string;
  };
};

type NotificationResponse =
  | {
      type: "notification.active";
      notifications: NotificationType[];
    }
  | {
      type: "notification.dismissed";
      dismissed: number;
    }
  | {
      type: "notification.new";
      notification: NotificationType;
    };

export const Notifications = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { sendJsonMessage, lastMessage } = useAuthenticatedWebSocket(
    `${import.meta.env.VITE_WS_URL}/ws/notifications`,
    {
      share: true,
    },
  );

  const closeNotification = (id: number) => {
    sendJsonMessage({ type: "dismiss_notification", dismiss: id });
    closeSnackbar(id);
  };

  const openNotification = (id: number, message: string, sub_type: "Warning" | "Information") => {
    enqueueSnackbar(message, {
      key: id,
      persist: true,
      variant: "alert",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      closeNotification: () => closeNotification(id),
      sub_type,
    });
  };

  useEffect(() => {
    if (lastMessage !== null) {
      const data = JSON.parse(lastMessage.data) as NotificationResponse;
      if (data.type === "notification.active") {
        data.notifications.forEach((notification: NotificationType) => {
          if (["Product"].includes(notification.notification_body.event_type) && notification.dismissed_at === null) {
            openNotification(
              notification.id,
              notification.notification_body.message,
              notification.notification_body.sub_type,
            );
          }
        });
      }
      if (data.type === "notification.dismissed") {
        closeSnackbar(data.dismissed);
      }
      if (data.type === "notification.new") {
        if (["Product"].includes(data.notification.notification_body.event_type)) {
          openNotification(
            data.notification.id,
            data.notification.notification_body.message,
            data.notification.notification_body.sub_type,
          );
        }
      }
    }
  }, [lastMessage]);

  return <></>;
};
